import UserRoles from "../components/Users/UserRoles";
import {PERM} from "../utilites/permissions";

const userRoles = [
  {
    path: '/user_roles/:id(\\d+)?',
    name: 'UserRoles',
    component: UserRoles,
    meta: {
      requiresAuth: true,
      permissions: [
        PERM.ROLE,
      ]
    },
    props: true,
  },
];

export default userRoles;



// WEBPACK FOOTER //
// ./src/router/userRoles.js